module.exports = __webpack_public_path__ + "static/media/feature-new-editor1.b169080f.png";